import { useEffect, useState } from 'react'
import { api } from '../services/api'

export function useReferenceList(type) {
  const [items, setItems] = useState([])

  useEffect(() => {
    let active = true
    api
      .get(`/reference/${type}?limit=200`)
      .then((data) => {
        if (active) setItems(data.items)
      })
      .catch(() => {
        if (active) setItems([])
      })
    return () => {
      active = false
    }
  }, [type])

  return items
}
